var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-body"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"card-h-title"},[_vm._v("时节气候特点")])]),_c('div',{staticClass:"card-body"},[_vm._v(" 初之气：主气厥阴风木，客气少阴君火。 "),_c('br'),_vm._v(" 壬寅岁初之气，自辛丑年大寒日申初，至是岁春分日午初，凡六十日八十七刻半。主位太角木，客气少阴火，中见木运，木火相得，运当其位，以奉少阳之政，而行春令，地气迁，风胜乃摇，寒乃去，候乃大温，草木早荣，寒来不杀，温病乃起。 ")])])])
}]

export { render, staticRenderFns }